import * as React from 'react'

type Option<T> = {
  value: T
  label: string
}

type ICreativesFilterState = {
  platforms: Option<string>[]
  states: Option<string>[]
  formats: Option<string>[]
  placements: Option<string>[]

  query: string
}

export function useCreativeFilters() {
  const [state, setState] = React.useState<ICreativesFilterState>({
    platforms: [],
    states: [],
    formats: [],
    placements: [],

    query: '',
  })

  const onMultiSelectChange = (prop: string) => (value: any) => {
    setState((state) => ({ ...state, [prop]: value }))
  }

  const onQueryChange = (query: string) =>
    setState((state) => ({ ...state, query }))

  return {
    state,

    onQueryChange,
    onFormatsChange: onMultiSelectChange('formats'),
    onStatesChange: onMultiSelectChange('states'),
    onPlacementsChange: onMultiSelectChange('placements'),
    onPlatformsChange: onMultiSelectChange('platforms'),
  }
}

export type CreativesFilter = ReturnType<typeof useCreativeFilters>
